<template>
  <div id="app">
    <!-- <div v-title data-title="「夜樱情趣」成人用品-情趣用品-两性用品-计生用品-性保健品-正品成人用品网站"></div> -->
    <router-view/>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Cookies from "js-cookie";
import { Notify } from "vant";
export default {
    name: 'App',
    data(){
      return{
        startx: "",
        starty: "",
        is_xcx: false,
        transitionName: "fade",
        userList: [],
        share_show: false,
        metaInfo:{}
      }
    },
    created(){
      // //判断是手机端还是电脑端
      if (this._isMobile()) {
          // console.log("手机端");
          window.location.href = 'https://www.yeying360.com';
      } else {
          // console.log("pc端");
      }
      window.vue1 = this;
      this.$store.commit("setTerminal");
      sessionStorage.getItem("appstores") && this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("appstores"))));
      //在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener("beforeunload", () => {
        sessionStorage.setItem("appstores", JSON.stringify(this.$store.state));
      });
      document.title = this.$store.state.appTitle;

    },
    computed: {
      ...mapState({
        isSDKReady: state => state.imUser.isSDKReady,
      }),
      groupList: function () {
        return this.$store.state.group.groupList;
      },
      ...mapGetters(["toAccount"]),
      getUser () {
        return this.$store.state.user;
      },
    },
    watch: {
      $route (to) {
        if (to.path != "/im/mes" && to.path != "/im/kf" && to.path != "/im/wechat/chat") {
          this.$store.commit("setUnStatusShop", {});
        }
      },
      getUser (val) {
        if (!this.$store.state.isLogin && JSON.stringify(val) != "{}") {
          if (val.im) {
            this.$nextTick(() => {
              this.$store.dispatch("login", {
                userID: val.im,
                userSig: val.im_sig
              });
            });
          }
        }
      },
    },
    mounted(){
      this.$api.getShop.getConfigData({}).then(res=>{
        if(res.code == 200){
          this.metaInfo = {
              title: res.result.head,
              keywords: '成人用品，情趣用品，两性用品，计生用品，性保健用品，性生活用品，性爱用品，夜樱情趣',
              description: res.result.jianjie
          }
          this.$store.commit("CAHNGE_META_INFO", this.metaInfo)
        }
      })
      // let metaInfo = {
      //     title: "「夜樱情趣」成人用品-情趣用品-两性用品-计生用品-性保健品-正品成人用品网站",
      //     keywords: "成人用品，情趣用品，两性用品，计生用品，性保健用品，性生活用品，性爱用品，夜樱情趣",
      //     description: "夜樱情趣专注高端成人用品18年，主营情趣用品，两性用品，计生用品，性保健用品，正品保障，自营仓储，入库检查，保险保障，私密发货，货到付款！"
      // }
      // this.$store.commit("CAHNGE_META_INFO", metaInfo)
      this.initListener();
    },
    methods:{
      //判断手机端还是pc端
      _isMobile() {
          let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
          return flag;
      },
      initListener () {
        
        // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
        this.tim.on(this.TIM.EVENT.SDK_READY, this.onReadyStateUpdate, this);
        // SDK NOT READT
        this.tim.on(this.TIM.EVENT.SDK_NOT_READY, this.onSdkNotReady, this);
        // 被踢出
        this.tim.on(this.TIM.EVENT.KICKED_OUT, ({ data: { type } }) => {
          const message =
            type === this.TIM.TYPES.KICKED_OUT_MULT_ACCOUNT
              ? "您的账号已在其他页面登录"
              : "您的账号已在其他设备登录";
          this.$toast.fail(message);
          this.$store.commit("toggleIsLogin", false);
          this.$store.commit("reset");
        });
        // SDK内部出错
        this.tim.on(this.TIM.EVENT.ERROR, this.onError);
        // 收到新消息
        this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage);
        // 会话列表更新
        this.tim.on(this.TIM.EVENT.CONVERSATION_LIST_UPDATED, event => {
          this.$store.commit("updateConversationList", event.data);
        });
        // 群组列表更新
        this.tim.on(this.TIM.EVENT.GROUP_LIST_UPDATED, event => {
          this.$store.commit("updateGroupList", event.data);
        });
        // 收到新的群系统通知
        this.tim.on(this.TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED, event => {
          const isKickedout = event.data.type === 4;
          const isCurrentConversation =
            `GROUP${event.data.message.payload.groupProfile.groupID}` ===
            this.currentConversation.conversationID;
          // 在当前会话被踢，需reset当前会话
          if (isKickedout && isCurrentConversation) {
            this.$store.commit("resetCurrentConversation");
          }
          // Notify({
          //     // title: "新系统通知",
          //     message: translateGroupSystemNotice(event.data.message),
          //     duration: 3000,
          //     onClick: () => {
          //         const SystemConversationID = "@TIM#SYSTEM";
          //         this.$store.dispatch("checkoutConversation", SystemConversationID);
          //     }
          // });
        });
        
      },
      onReceiveMessage ({ data: messageList }) {
        this.handleAt(messageList);
        messageList.forEach(item => {
          if (item.conversationType == "GROUP" && item.ID.indexOf('GROUP@TGS') >= 0) {
            this.tim.setMessageRead({
              conversationID: item.conversationID
            });
            if (item.elements[0].content.data == "present") {
              this.$store.commit("addLivePresent", [item]);
            } else {
              this.$store.commit("addLiveMsg", [item]);
            }
          } else if (this.$route.path == "/im/mes") {
            messageList.forEach(item => {
              if (this.$route.query.id == item.conversationID) {
                this.tim.setMessageRead({
                  conversationID: item.conversationID
                });
              }
            });
          } else if (this.$route.path == "/im/wechat/chat") {
            messageList.forEach(item => {
              if (item.conversationID.indexOf(this.$route.query.id) >= 0) {
                this.tim.setMessageRead({
                  conversationID: item.conversationID
                });
              }
            });
          }
        });
        this.$store.commit("pushCurrentMessageList", messageList);
      },
      onError ({ data: error }) {
        new Error(error.message);
        // this.$toast.fail(error.message);
      },
      onReadyStateUpdate () {
        const isSDKReady = name === this.TIM.EVENT.SDK_READY ? true : false;
        this.$store.commit("toggleIsSDKReady", true);
        // console.log(data)
        if (isSDKReady) {
          this.tim.getMyProfile().then(({ data }) => {
            this.$store.commit("updateCurrentUserProfile", data);
          });
        }
      },
      /**
       * 处理 @ 我的消息
       * @param {Message[]} messageList
       */
      handleAt (messageList) {
        // 筛选有 @ 符号的文本消息
        var that = this;
        const atTextMessageList = messageList.filter(
          message =>
            message.type === this.TIM.TYPES.MSG_TEXT &&
            message.payload.text.includes("@")
        );

        for (let i = 0; i < atTextMessageList.length; i++) {
          const message = atTextMessageList[i];
          const matched = message.payload.text.match(/@\w+/g);
          if (!matched) {
            continue;
          }
          // @ 我的
          if (matched.includes(`@${this.currentUserProfile.userID}`)) {
            // 当前页面不可见时，调用window.Notification接口，系统级别通知。
            if (document.hidden) {
              this.notifyMe(message);
            }

            var groupLists = that.groupList;
            for (var k in groupLists) {
              if (groupLists[k].groupID == message.conversationID.slice(5)) {
                Notify({
                  // title: `有人在群${message.conversationID.slice(5)}提到了你`,
                  // message: message.payload.text,
                  message: `有人在群 ${groupLists[k].name} 提到了你`,
                  duration: 3000
                });
              } else {
                break;
              }
            }

            this.$bus.$emit("new-messsage-at-me", {
              data: { conversationID: message.conversationID }
            });
          }
        }
      },
      /**
       * 使用 window.Notification 进行全局的系统通知
       * @param {Message} message
       */
      notifyMe (message) {
        // 需检测浏览器支持和用户授权
        if (!("Notify" in window)) {
          return;
        } else if (window.Notification.permission === "granted") {
          this.handleNotify(message);
        } else if (window.Notification.permission !== "denied") {
          window.Notification.requestPermission().then(permission => {
            // 如果用户同意，就可以向他们发送通知
            if (permission === "granted") {
              this.handleNotify(message);
            }
          });
        }
      },
      handleNotify (message) {
        const notification = new window.Notify("有人提到了你", {
          body: message.payload.text
        });
        notification.onclick = () => {
          window.focus();
          this.$store.dispatch("checkoutConversation", message.conversationID);
          notification.close();
        };
      },
      onSdkNotReady () {
        this.$store.commit("toggleIsSDKReady", false);
        this.tim.login({userID: this.$store.getters.userID, userSig: this.$store.getters.userSig});
        this.tim.getMyProfile().then(({ data }) => {
          this.$store.commit("updateCurrentUserProfile", data);
        });
      },
    }
}
</script>

<style scoped>
  /* #app{
    border: 1px solid red;
    width: 100%;
    height: 100%;
    background-color: #dde4ea;
  } */
</style>



// WEBPACK FOOTER //
// src/App.vue